import React from 'react';
import { View, Text, StyleSheet } from '@react-pdf/renderer';
import {
  TITLE_PAGE_TABLE_FIELD_KEYS,
  shouldIncludeTitlePageTableRow,
} from '../../utils/protocolTitlePageFields';
import { pdfTableStyles } from './pdfTable';
import { PDF_FONT_BOLD, PDF_FONT_REGULAR } from '../../utils/pdfFontSetup';
import { renderHybridPdfText } from '../../utils/renderHybridPdfText';

const FONT = PDF_FONT_REGULAR;

const styles = StyleSheet.create({
  topSpacer: { height: 8 },
  labelCell: {
    width: '38%',
    padding: 4,
    borderRightWidth: 1,
    borderRightColor: '#000000',
  },
  valueCell: {
    width: '62%',
    padding: 4,
  },
  labelText: {
    fontFamily: PDF_FONT_BOLD,
    fontSize: 11,
  },
  bodyText: {
    fontFamily: FONT,
    fontSize: 11,
    lineHeight: 1.3,
  },
});

function renderValueLines(text, fieldKey) {
  const raw = String(text || '').trim();
  if (!raw) return null;
  if (fieldKey === 'regulatoryIdentifiers' && raw.includes('\n')) {
    return raw
      .split(/\s*\n\s*/)
      .filter(Boolean)
      .map((line, i) => (
        <Text key={i} style={styles.bodyText}>
          {renderHybridPdfText(line, styles.bodyText, `tp-${i}-`)}
        </Text>
      ));
  }
  return <Text style={styles.bodyText}>{renderHybridPdfText(raw, styles.bodyText, 'tp-')}</Text>;
}

/**
 * Word-style protocol title page (matches generateTitlePageContent layout).
 * Medical expert and other fields appear only in the key/value table.
 */
const ProtocolPdfTitlePage = ({ config }) => {
  if (!config?.enabled) return null;

  const tableRows = TITLE_PAGE_TABLE_FIELD_KEYS.map((fieldKey) => {
    const field = config[fieldKey];
    if (!shouldIncludeTitlePageTableRow(fieldKey, field)) return null;
    return { fieldKey, label: field.label || '', text: String(field.text || '').trim() };
  }).filter(Boolean);

  return (
    <View>
      <View style={styles.topSpacer} />

      {tableRows.length > 0 && (
        <View style={[pdfTableStyles.table, { marginBottom: 8 }]} wrap>
          {tableRows.map((row) => (
            <View key={row.fieldKey} wrap={false} style={pdfTableStyles.row}>
              <View style={styles.labelCell}>
                <Text style={[styles.labelText, { lineHeight: 1.3 }]}>
                  {renderHybridPdfText(row.label, styles.labelText, 'lbl-')}
                </Text>
              </View>
              <View style={[styles.valueCell, pdfTableStyles.cellLast]}>
                {renderValueLines(row.text, row.fieldKey)}
              </View>
            </View>
          ))}
        </View>
      )}
    </View>
  );
};

export default ProtocolPdfTitlePage;
